var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoverning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 18.3333H17.5V11.6658C18.42 11.6625 19.1667 10.9142 19.1667 9.99333C19.1667 9.38 18.8317 8.81667 18.2942 8.525L11.1242 4.61417C11.0308 4.56333 10.93 4.53667 10.8325 4.5V3.65L13.0283 2.2875C13.4408 2.0125 13.4317 1.40417 13.0117 1.14167L10.96 0.179167C10.7725 0.0616667 10.5558 0 10.3342 0C9.6825 0 9.15333 0.528333 9.15333 1.18083V4.16667H9.16583V4.5C9.06833 4.5375 8.9675 4.56333 8.87416 4.61417L1.70583 8.525C1.16749 8.8175 0.833328 9.37917 0.833328 9.99333C0.833328 10.9142 1.58083 11.6625 2.5 11.6658V18.3333H1.66666C1.20666 18.3333 0.833328 18.7058 0.833328 19.1667C0.833328 19.6275 1.20666 20 1.66666 20H18.3333C18.7942 20 19.1667 19.6275 19.1667 19.1667C19.1667 18.7058 18.7942 18.3333 18.3333 18.3333ZM9.16666 11.6667V18.3333H7.5V11.6667H9.16666ZM10.8333 11.6667H12.5V18.3333H10.8333V11.6667ZM14.1667 11.6667H15.8333V18.3333H14.1667V11.6667ZM4.16666 11.6667H5.83333V18.3333H4.16666V11.6667Z",
    fill: "url(#paint0_linear_381_44)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_381_44",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoverning);
export default __webpack_public_path__ + "static/media/governing.1149091633fe54ff72e13b937dcecac0.svg";
export { ForwardRef as ReactComponent };